import { put, takeEvery } from "redux-saga/effects"
import { request } from "src/engine/modules/session/effects"
import { REMOVE_LIST_ITEM } from "../actions/types"
import { removeListError, removeListSuccess } from "../actions/creators/remove"

// remove item from list saga
function* requestRemove(action) {
  const { basicUrl, id } = action.config

  try {
    const result = yield request(
      basicUrl,
      {},
      {
        method: `delete`,
        body: [id],
      },
    )
    yield put(removeListSuccess(action, result))
  } catch (error) {
    yield put(removeListError(action, error))
  }
}

export default function* removeSaga() {
  yield takeEvery(REMOVE_LIST_ITEM, requestRemove)
}
